import { createPortal } from "react-dom";

export interface FloatingGhost {
  x: number;
  y: number;
  width: number;
  height: number;
  clientName: string;
  hours: number;
  color: string;
  bgColor: string;
}

export function FloatingGhostOverlay({ ghost }: { ghost: FloatingGhost }) {
  return createPortal(
    <div
      className="pointer-events-none fixed z-50 flex flex-col items-center justify-center"
      style={{
        left: ghost.x - ghost.width / 2,
        top: ghost.y - 12,
        width: ghost.width,
        height: ghost.height,
        background: ghost.bgColor,
        border: `2px dashed ${ghost.color}`,
        borderRadius: 5,
        opacity: 0.85,
        boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
      }}
    >
      <span
        className="text-h4 font-medium"
        style={{
          color: ghost.color,
          lineHeight: "100%",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: ghost.width - 8,
          textAlign: "center",
        }}
      >
        {ghost.clientName}
      </span>
      <span
        className="text-h4 font-medium"
        style={{ color: ghost.color, lineHeight: "100%", opacity: 0.7 }}
      >
        {ghost.hours}h
      </span>
    </div>,
    document.body,
  );
}
